module.exports = __webpack_public_path__ + "static/media/customizable.e7133ad1.gif";